import { ReactNode, useMemo } from 'react'
import { createHtmlPortalNode, InPortal } from 'react-reverse-portal'
import { CampaignModel } from '../../shared'
import { CampaignCommonContext, CampaignPermissions } from './campaign-common-context'
import {
	CampaignNavConfig,
	CampaignNavPortalTargetContext,
	ProvidedCampaignNavConfigContext,
} from './campaign-nav-context'
import { PortalCampaignNav } from './portal-campaign-nav'

/**
 * This wrapper provides the navigation context and sets the in-portal for all
 * campaign-related views.
 */
export type CampaignWrapperProps = {
	children: ReactNode
	campaignNav: CampaignNavConfig
	campaign: CampaignModel
	isLoading: boolean
	permissions: CampaignPermissions

	/** Callback to move the campaign back to draft. Returns a promise that resolves after redirect. */
	onPullToDraft?: () => Promise<void>
}

export function CampaignWrapper({
	children,
	campaignNav,
	campaign,
	isLoading,
	permissions,
	onPullToDraft,
}: CampaignWrapperProps) {
	const campaignNavTargetNode = useMemo(() => createHtmlPortalNode(), [])

	return (
		<div>
			<CampaignCommonContext.Provider value={{ permissions }}>
				<ProvidedCampaignNavConfigContext.Provider value={campaignNav}>
					<InPortal node={campaignNavTargetNode}>
						<PortalCampaignNav
							campaign={campaign}
							isLoading={isLoading}
							onPullToDraft={onPullToDraft}
						/>
					</InPortal>
					<CampaignNavPortalTargetContext.Provider value={{ campaignNavTargetNode }}>
						{children}
					</CampaignNavPortalTargetContext.Provider>
				</ProvidedCampaignNavConfigContext.Provider>
			</CampaignCommonContext.Provider>
		</div>
	)
}
